require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-go-to-designer-est-living-featuring-armadale-residence.json") })
        }
      }, "path---journal-go-to-designer-est-living-featuring-armadale-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-go-to-designer-est-living-featuring-armadale-residence!./.cache/json/journal-go-to-designer-est-living-featuring-armadale-residence.json
// module id = 488
// module chunks = 231608221292675